<!-- 营销插件 -->
<template>
  <div class="warp">
    <div class="banner">
      <br />
      <p>门店营销系统</p>
      <span>
        O2O多门店解决方案
        <br />
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="item1">
      <div class="title">
        <p>
          <b>营销系统是什么?</b>
          <span></span>
        </p>
      </div>
      <div class="t1">
        <p>了解客户 留住客户</p>
        <p>这是一款能够帮助企业面向多行业，快速搭建会员营销平台的系统。</p>
        <p>平台利用系统快速招商，短时间内上线运营；</p>
        <p>商家利用系统可轻松拓客、快速吸粉</p>
      </div>
      <ul class="t2">
        <li>
          <img src="../../assets/images/marke02.png" />
          <span>专业软件系统</span>
        </li>
        <li>
          <img src="../../assets/images/marke03.png" />
          <span>高品质开发服务</span>
        </li>
        <li>
          <img src="../../assets/images/marke04.png" />
          <span>多种盈利模式</span>
        </li>
        <li>
          <img src="../../assets/images/marke05.png" />
          <span>高效运营实操</span>
        </li>
      </ul>
    </div>
    <div class="item2">
      <div class="title">
        <p>
          <b>我们能解决哪些问题?</b>
          <span></span>
        </p>
      </div>
      <div class="item2">
        <div class="img">
          <img src="../../assets/images/marke06.jpg" />
        </div>
        <ul class="list2">
          <li>
            <span>
              <b>•</b>顾客太少！生意太差！
            </span>
            <p>店员拓客 全民分销拓客两大核武器让您的店铺顾客盈门</p>
          </li>
          <li>
            <span>
              <b>•</b>回头客少 二次消费率低
            </span>
            <p>通过数字化会员体系和会员画像功能，做精准的会员营销</p>
          </li>
          <li>
            <span>
              <b>•</b>营销成本高 垃圾粉多
            </span>
            <p>精准营销、深度场景化营销方案和会员转化功能为您拓展精准顾客</p>
          </li>
          <li>
            <span>
              <b>•</b>门店多 线上线下杂乱无章
            </span>
            <p>多门店线上线下业务、会员数据统一，打通O2O线上线下业务闭环</p>
          </li>
          <li>
            <span>
              <b>•</b>管理效率低 员工不积极
            </span>
            <p>对店员拓客数量、发券数量进行考核提高效率，通过打赏提高积极性</p>
          </li>
          <li>
            <span>
              <b>•</b>收银设备多 财务管理混乱
            </span>
            <p>全通道融合线上线下的收银体系，线上线下全通道财务数据统一</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="item3">
      <div class="bg1"></div>
      <div class="bg2"></div>
      <div class="title">
        <p>
          <b>功能特色</b>
          <span></span>
        </p>
      </div>
      <ul class="list3">
        <li>
          <img src="../../assets/images/marke07.jpg" />
          <p>
            精准客户获取
            <br />线下流量革命
          </p>
        </li>
        <li>
          <img src="../../assets/images/marke08.jpg" />
          <p>
            店员及全民
            <br />线下拓客营销
          </p>
        </li>
        <li>
          <img src="../../assets/images/marke09.jpg" />
          <p>
            APP中管理业务
            <br />会员及财务
          </p>
        </li>
        <li>
          <img src="../../assets/images/marke10.jpg" />
          <p>
            游戏营销及场景化
            <br />游戏助力营销
          </p>
        </li>
        <li>
          <img src="../../assets/images/marke11.jpg" />
          <p>
            全通道融合
            <br />智慧收银体系
          </p>
        </li>
        <li>
          <img src="../../assets/images/marke12.jpg" />
          <p>
            面向新零售的电商
            <br />分销O2O体系
          </p>
        </li>
      </ul>
    </div>

    <div class="item4">
      <div class="title">
        <p>
          <b>
            多种工具组合衍生
            <br />无数营销花式玩法
          </b>
          <span></span>
        </p>
      </div>
      <div class="img">
        <img src="../../assets/images/marke15.jpg" />
      </div>
      <div class="t3">
        <div class="top">丰富新颖的电商模式及营销工具</div>
        <ul>
          <li>
            <i></i>
            <span>支付营销</span>
          </li>
          <li>
            <i></i>
            <span>直销</span>
          </li>
          <li>
            <i></i>
            <span>分销</span>
          </li>
          <li>
            <i></i>
            <span>返利</span>
          </li>
          <li>
            <i></i>
            <span>一元购</span>
          </li>
          <li>
            <i></i>
            <span>拼团</span>
          </li>
          <li>
            <i></i>
            <span>抢购</span>
          </li>
          <li>
            <i></i>
            <span>秒杀</span>
          </li>
          <li>
            <i></i>
            <span>卡券</span>
          </li>
          <li>
            <i></i>
            <span>积分</span>
          </li>
          <li>
            <i></i>
            <span>会员营销</span>
          </li>
          <li>
            <i></i>
            <span>更多</span>
          </li>
        </ul>
      </div>

      <div class="t3">
        <div class="top">吸粉的功能设计</div>
        <ul>
          <li>
            <i></i>
            <span>签到礼</span>
          </li>
          <li>
            <i></i>
            <span>注册礼</span>
          </li>
          <li>
            <i></i>
            <span>拉客有礼</span>
          </li>
          <li>
            <i></i>
            <span>新人礼</span>
          </li>
          <li>
            <i></i>
            <span>消费充值礼</span>
          </li>
          <li>
            <i></i>
            <span>生日关怀</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="item5">
      <div class="title">
        <p>
          <b>
            打造员工的个人品牌IP
            <br />为企业塑造完美的品牌形象
          </b>
          <span></span>
        </p>
      </div>
      <ul class="list5">
        <li>
          <span>个人/品牌IP</span>
          <p>员工可展示自己的成果、业绩、老客良好的使用效果，一键分享微信、微博等社交平台</p>
        </li>
        <li>
          <span>派发优惠券</span>
          <p>通过员工与客户深度沟通，有针对性推送优惠活动及产品，提升客户30%的购买意愿</p>
        </li>
        <li>
          <span>三级分销</span>
          <p>店员和老客户通过营销拉新，获得三级返佣激励，让人人都是你的分销商</p>
        </li>
      </ul>
    </div>

    <div class="item6">
      <div class="bg"></div>
      <div class="title">
        <p>
          <b>营销系统适用行业</b>
          <span></span>
        </p>
      </div>
      <ul class="list6">
        <li>
          <span>
            <img src="../../assets/images/marke21.png" />
          </span>
          <p>母婴</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke22.png" />
          </span>
          <p>培训</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke23.png" />
          </span>
          <p>服装</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke24.png" />
          </span>
          <p>酒店</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke25.png" />
          </span>
          <p>KTV娱乐</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke26.png" />
          </span>
          <p>餐饮</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke27.png" />
          </span>
          <p>零售</p>
        </li>
        <li>
          <span>
            <img src="../../assets/images/marke28.png" />
          </span>
          <p>更多</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "marketing",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/shortVideoBanner.jpg") no-repeat left
      top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    .button-text {
      background-color: #ffaf58;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .title {
    text-align: center;
    padding-top: 1.1rem;
    padding-bottom: 0.4rem;
    p {
      display: inline-block;
      font-size: 0.48rem;
      position: relative;
      b {
        position: relative;
        z-index: 10;
      }
      span {
        background-color: rgb(216, 191, 248);
        width: 104%;
        height: 0.2rem;
        border-radius: 0.2rem;
        position: absolute;
        left: -2%;
        bottom: 0.05rem;
      }
    }
  }
  .item1 {
    .t1 {
      text-align: center;
      font-style: 0.3rem;
      line-height: 0.55rem;
      color: #666;
    }
    .t2 {
      display: flex;
      padding-top: 0.5rem;
      li {
        flex: 1;
        text-align: center;
        img {
          width: 1.5rem;
        }
        span {
          display: block;
          font-size: 0.32rem;
          padding: 0.2rem 0;
        }
      }
    }
  }
  .item2 {
    .img {
      img {
        width: 100%;
      }
    }
    .list2 {
      li {
        text-align: center;
        padding-top: 0.4rem;
        padding-bottom: 0.2rem;
        span {
          font-size: 0.38rem;
          font-weight: 500;
          color: #333;
          display: block;
          padding: 0.1rem 0;
          b {
            font-weight: 900;
            color: #af66ef;
            padding-right: 0.1rem;
            font-size: 0.46rem;
          }
        }
        p {
          font-size: 0.32rem;
          color: #666;
        }
      }
    }
  }
  .item3 {
    position: relative;
    .bg1 {
      width: 100%;
      height: 4rem;
      background: url("../../assets/images/marke13.png") no-repeat left center;
      background-size: 100% auto;
      position: absolute;
      left: 0;
      top: 0;
    }
    .bg2 {
      width: 100%;
      height: 3rem;
      background: url("../../assets/images/marke14.png") no-repeat left center;
      background-size: 100% auto;
      position: absolute;
      left: 0;
      bottom: -2.5rem;
    }
    .list3 {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 33.3333%;
        text-align: center;
        padding-top: 0.8rem;
        img {
          width: 1.2rem;
        }
        p {
          display: block;
          font-size: 0.32rem;
          line-height: 0.5rem;
          padding-top: 0.2rem;
        }
      }
    }
  }
  .item4 {
    padding: 0.5rem 0;
    .img {
      img {
        width: 100%;
      }
    }
    .t3 {
      margin-top: 0.3rem;
      .top {
        text-align: center;
        font-size: 0.4rem;
        line-height: 0.6rem;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0.3rem 0.5rem;

        li {
          width: 33.3333%;
          line-height: 0.8rem;
          display: flex;
          align-items: center;
          font-size: 0.32rem;
          padding-left: 0.5rem;
          i {
            border: 1px solid #582484;
            width: 6px;
            height: 6px;
            border-radius: 1rem;
            margin-top: -2px;
            margin-right: 0.2rem;
          }
        }
      }
    }
  }
  .item5 {
    background: url("../../assets/images/marke19.png") no-repeat left 3.5rem;
    background-size: 100% auto;
    .list5 {
      padding: 0 0.6rem;
      li {
        &:nth-child(1) {
          background-image: url("../../assets/images/marke16.jpg");
        }
        &:nth-child(2) {
          background-image: url("../../assets/images/marke17.jpg");
        }
        &:nth-child(3) {
          background-image: url("../../assets/images/marke18.jpg");
        }
        background-size: 3rem auto;
        background-repeat: no-repeat;
        background-position: right bottom;
        background-color: #fff;
        box-shadow: 0px 3px 29px 0px rgba(145, 156, 247, 0.4);
        padding: 0.35rem 0.45rem;
        margin-top: 0.55rem;

        span {
          font-size: 0.36rem;
          display: block;
          padding-bottom: 0.1rem;
        }
        p {
          font-size: 0.34rem;
          color: #888;
          line-height: 0.5rem;
        }
      }
    }
  }
  .item6 {
    position: relative;
    padding-top: 0.8rem;
    .bg {
      width: 100%;
      height: 4rem;
      background: url("../../assets/images/marke20.png") no-repeat left center;
      background-size: 100% auto;
      position: absolute;
      left: 0;
      top: 0;
    }
    .list6 {
      display: flex;
      flex-wrap: wrap;
      padding: 0.4rem;
      li {
        width: 1.52rem;
        background-color: #fff;
        
        text-align: center;
        margin:.3rem 0.45rem;
        span {
          box-shadow: 0px 0px 35px 0px rgba(175, 86, 214, 0.19);
          width: 1.52rem;
          height: 1.52rem;
          display: block;
          padding: 0.16rem;
          img {
          width: 1.2rem;
        }
        }
        p{
            display: block;
            width: 1.52rem;
            font-size: .321rem;
            padding: .2rem 0;
        }
        
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/marketing.vue